(()=>{
  const norm=s=>(s||'').replace(/\s+/g,' ').trim();
  const collectionMap={
    'study table':'/collections/study-tables-workstations',
    'study':'/collections/study-tables-workstations',
    'dining table':'/collections/dining-tables',
    'dining':'/collections/dining-tables',
    'shoe rack':'/collections/shoe-racks',
    'tv unit':'/collections/tv-units',
    'coffee table':'/collections/coffee-tables',
    'bar cabinet':'/collections/bar-cabinets',
    'bookshelf':'/collections/bookshelves',
    'living room':'/collections/living-room-furniture',
    'bed':'/collections/beds',
    'bedroom':'/collections/beds',
    'foldable':'/collections/foldable-furniture',
    'storage':'/collections/storage-furniture',
    'computer table':'/collections/computer-tables',
    'gaming table':'/collections/gaming-desks',
    'furniture':'/collections/all-furniture'
  };

  const rewriteCatalogLink=(a)=>{
    if(!a)return;
    const raw=a.getAttribute('href')||'';
    if(raw==='/collections/all'){
      a.setAttribute('href','/collections/all-furniture');
      return;
    }
    if(!/^\/search\?/i.test(raw))return;
    try{
      const u=new URL(raw,window.location.origin);
      const q=(u.searchParams.get('q')||'').replace(/\+/g,' ').trim().toLowerCase();
      if(collectionMap[q])a.setAttribute('href',collectionMap[q]);
    }catch(e){}
  };

  const hideMarketplaceSku=(el,t)=>{
    if(!/^B0[A-Z0-9]{8}$/i.test(t))return false;
    let row=el;
    for(let i=0;i<4&&row&&row.parentElement;i++,row=row.parentElement){
      if(/sku/i.test(norm(row.textContent)) && norm(row.textContent).length<80){
        row.classList.add('klaxon-clean-hidden');
        row.setAttribute('aria-hidden','true');
        return true;
      }
    }
    return false;
  };

  const run=()=>{
    document.querySelectorAll('body *').forEach(el=>{
      if(el.children.length)return;
      const t=norm(el.textContent);
      if(t==='Get help from our experts 24/7')el.textContent='KLAXON product & order support';
      if(t==='My Store')el.textContent='KLAXON Furniture';
      if(t==='FREE RETURNS')el.textContent='RETURNS & REPLACEMENT';
      if(t==='SUPPORT 24/7')el.textContent='CUSTOMER SUPPORT';
      if(t==='SECURED PAYMENTS')el.textContent='SECURE CHECKOUT';
      if(t==='Exclusive section that stores the history of product views')el.textContent='Products you recently viewed.';
      if(/^Amazon reference(?: ASIN)?:/i.test(t)){el.textContent='';el.setAttribute('aria-hidden','true')}
      if(t==='Suspendisse ultrices viverra nibh in mollis quisque dictum mattis elementum mauris in luctus diam.'){el.textContent='';el.setAttribute('aria-hidden','true')}
      if(t==='Subscribe Us'){const p=el.closest('.modal-wrap,[class*="popup"],[class*="newsletter"]');if(p){p.classList.add('klaxon-clean-hidden');p.setAttribute('aria-hidden','true')}}
      hideMarketplaceSku(el,t);
    });

    document.querySelectorAll('input[placeholder]').forEach(i=>{
      if(/search by title, sku, type, vendor, description or tags/i.test(i.placeholder||''))i.placeholder='Search KLAXON furniture';
    });
    document.querySelectorAll('img[alt="Logo"],img[alt="Logo Logo"]').forEach(i=>i.alt='KLAXON Furniture');
    document.querySelectorAll('[data-klx-news-popup]').forEach(el=>el.remove());

    document.querySelectorAll('a').forEach(a=>{
      rewriteCatalogLink(a);
      const t=norm(a.textContent);
      const href=a.getAttribute('href')||'';
      if(t==='Sizing guide'||t==='Measure Your Space'){a.textContent='Measure Your Space';a.setAttribute('href','/pages/measure-your-space');a.dataset.klaxonInfoLink='measure'}
      if(t==='Delivery and Return'||t==='Shipping & Delivery'){a.textContent='Shipping & Delivery';a.setAttribute('href','/pages/shipping-delivery');a.dataset.klaxonInfoLink='shipping'}
      if(href==='#'&&/continue shopping/i.test(t))a.setAttribute('href','/collections/all-furniture');
      if(href==='#'&&/read more/i.test(t)){const card=a.closest('.page-search-grid');const dest=card&&card.querySelector('.page-search-grid-name[href]');if(dest)a.setAttribute('href',dest.getAttribute('href'))}
    });

    document.querySelectorAll('.klx-room').forEach(card=>{
      const title=norm(card.querySelector('strong')?.textContent).toLowerCase();
      if(title==='bedroom')card.setAttribute('href','/collections/beds');
    });

    /* Story copy is authored directly in the KLAXON home section. */

    if(document.title.includes('My Store'))document.title=document.title.replace(/My Store/g,'KLAXON Furniture');
  };

  document.addEventListener('click',e=>{
    const a=e.target.closest&&e.target.closest('a[data-klaxon-info-link]');
    if(!a)return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.assign(a.getAttribute('href'));
  },true);

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',run,{once:true}):run();
  window.addEventListener('load',run,{once:true});
})();

/* KLAXON cart reliability layer.
   Keeps Lumia's existing mini-cart UI, but owns standard Add to Cart submissions
   so a missing/failed cart component can never leave the button stuck loading. */
(()=>{
  'use strict';

  const root=()=>window.Shopify?.routes?.root||'/';
  const cartUrl=()=>window.routes?.cart_url||window.routes?.cart||`${root()}cart`;
  const cartAddUrl=()=>window.routes?.cart_add_url||window.routes?.cart_add||`${root()}cart/add`;

  /* Lumia's bundled cart storage refresh expects a locale-aware relative root. */
  if(window.Shopify?.routes?.root)window.shopUrl=window.Shopify.routes.root;

  const setBusy=(productForm,form,button,busy)=>{
    productForm.dataset.klaxonCartBusy=busy?'true':'false';
    form.classList.toggle('loading-process',busy);
    button.classList.toggle('loading-process',busy);
    if(busy)button.setAttribute('aria-disabled','true');
    else button.removeAttribute('aria-disabled');
    button.querySelector('.loading-overlay__spinner')?.classList.toggle('hidden',!busy);
  };

  const showError=(productForm,message)=>{
    const wrapper=productForm.querySelector('[data-error-message-wrapper]')||
      productForm.closest('[data-section-render]')?.querySelector('[data-error-message-wrapper]');
    const target=wrapper?.querySelector('[data-error-message]');
    if(wrapper)wrapper.classList.remove('hidden');
    if(target)target.textContent=message||window.cartStrings?.error||'Unable to add this item to the cart. Please try again.';
  };

  const sectionsFor=(cartItems)=>{
    if(!cartItems||typeof cartItems.getSectionsToRender!=='function')return [];
    try{
      return Array.from(new Set(
        cartItems.getSectionsToRender()
          .filter(item=>item?.id&&document.querySelector(`#${CSS.escape(item.id)}`))
          .map(item=>item.section)
          .filter(Boolean)
      )).slice(0,5);
    }catch(error){
      console.error('KLAXON cart section discovery failed',error);
      return [];
    }
  };

  const refreshDrawer=(cartItems,response)=>{
    if(!cartItems||!response?.sections||typeof cartItems.renderContents!=='function')return false;
    try{
      cartItems.renderContents(response);
      cartItems.toggleEmptyClass?.(response);
      cartItems.setParsedState?.(response);
      cartItems.setCartJs?.();
      cartItems.cartToggle?.();
      document.dispatchEvent(new CustomEvent('klaxon:cart-updated',{detail:response}));
      return true;
    }catch(error){
      console.error('KLAXON cart drawer refresh failed',error);
      return false;
    }
  };

  document.addEventListener('submit',async event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;

    const productForm=form.closest('product-form');
    if(!productForm||productForm.closest('cart-items'))return;
    if('onlyAnimation' in productForm.dataset)return;

    const button=event.submitter || form.querySelector('[type="submit"][name="add"], [data-action="add"]');
    if(!(button instanceof HTMLElement))return;
    if(button.getAttribute('name')!=='add'&&!button.matches('[data-action="add"]'))return;

    /* Let specialized multi-product/bundle handlers keep their own workflow. */
    if(productForm.multipleForms||productForm.hasAttribute('data-multiple-forms'))return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if(productForm.dataset.klaxonCartBusy==='true')return;
    setBusy(productForm,form,button,true);

    const cartItems=document.querySelector('cart-items');
    const formData=new FormData(form);
    const sections=sectionsFor(cartItems);
    if(sections.length){
      formData.set('sections',sections.join(','));
      formData.set('sections_url',window.location.pathname||root());
    }

    try{
      const response=await fetch(cartAddUrl(),{
        method:'POST',
        headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'},
        body:formData
      });

      let data=null;
      try{data=await response.json();}catch(parseError){
        throw new Error('The cart returned an invalid response.');
      }

      if(!response.ok||data?.status){
        throw new Error(data?.description||data?.message||'Unable to add this item to the cart.');
      }

      if(refreshDrawer(cartItems,data))return;

      /* Product was added successfully; use the cart page as a guaranteed-safe fallback. */
      window.location.assign(cartUrl());
    }catch(error){
      console.error('KLAXON add to cart failed',error);
      showError(productForm,error?.message);
    }finally{
      setBusy(productForm,form,button,false);
    }
  },true);
})();


/* KLAXON nav label patch: Study & Work -> Study Tables */
(()=>{
  const apply=()=>{
    document.querySelectorAll('header a[href*="/collections/study-tables-workstations"]').forEach(a=>{
      const walker=document.createTreeWalker(a,NodeFilter.SHOW_TEXT);
      let node;
      while((node=walker.nextNode())){
        const raw=node.nodeValue||'';
        if(raw.replace(/\s+/g,' ').trim()==='Study & Work'){
          const lead=(raw.match(/^\s*/)||[''])[0];
          const tail=(raw.match(/\s*$/)||[''])[0];
          node.nodeValue=lead+'Study Tables'+tail;
        }
      }
    });
  };
  document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded',apply,{once:true})
    : apply();
  window.addEventListener('load',apply,{once:true});
})();

/* KLAXON category carousel and autoplay brand film */
(()=>{
  const init=()=>{
    document.querySelectorAll('.klx-category-scroll-wrap').forEach(wrap=>{
      if(wrap.dataset.klxReady==='1')return;
      wrap.dataset.klxReady='1';
      const scroller=wrap.querySelector('[data-klx-cat-scroll]');
      const prev=wrap.querySelector('[data-klx-cat-prev]');
      const next=wrap.querySelector('[data-klx-cat-next]');
      if(!scroller)return;
      const move=dir=>{
        const card=scroller.querySelector('.klx-category-card');
        const styles=getComputedStyle(scroller);
        const gap=parseFloat(styles.columnGap||styles.gap||'14')||14;
        const step=(card?.getBoundingClientRect().width||190)+gap;
        scroller.scrollBy({left:dir*step*2,behavior:'smooth'});
      };
      prev?.addEventListener('click',()=>move(-1));
      next?.addEventListener('click',()=>move(1));
    });

    document.querySelectorAll('[data-klx-brand-video]').forEach(video=>{
      if(video.dataset.klxReady==='1')return;
      video.dataset.klxReady='1';
      video.muted=true;
      video.defaultMuted=true;
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        video.pause();
        return;
      }
      const play=()=>video.play().catch(()=>{});
      if('IntersectionObserver' in window){
        const io=new IntersectionObserver(entries=>{
          entries.forEach(entry=>entry.isIntersecting&&entry.intersectionRatio>=.25?play():video.pause());
        },{threshold:[0,.25,.6]});
        io.observe(video);
      }else play();
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
  window.addEventListener('load',init,{once:true});
})();

/* KLAXON brand film sound control */
(()=>{
  const initSound=()=>{
    document.querySelectorAll('[data-klx-video-sound]').forEach(btn=>{
      if(btn.dataset.klxSoundReady==='1')return;
      btn.dataset.klxSoundReady='1';
      const stage=btn.closest('.klx-media-stage');
      const video=stage?.querySelector('[data-klx-brand-video]');
      if(!video)return;
      btn.addEventListener('click',()=>{
        const turningOn=video.muted;
        video.muted=!turningOn;
        video.defaultMuted=!turningOn;
        btn.setAttribute('aria-pressed',turningOn?'true':'false');
        btn.setAttribute('aria-label',turningOn?'Turn video sound off':'Turn video sound on');
        const label=btn.querySelector('span');
        if(label)label.textContent=turningOn?'Mute':'Sound';
        if(turningOn)video.play().catch(()=>{});
      });
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',initSound,{once:true}):initSound();
  window.addEventListener('load',initSound,{once:true});
})();